// src/components/Header.tsx
import React, { useState } from "react";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full bg-black text-white">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 pr-4 pt-9 pb-9">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src="/images/logo-horizontal.png" // Reemplaza con tu ruta de logo
            alt="Magníficos Ya!"
            className="h-20"
          />
        </div>

        {/* Navegación Desktop */}
        <nav className="hidden md:flex items-center space-x-8 text-lg">
          <a href="#modelo" className="hover:text-yellow-400 transition">
            Modelo
          </a>
          <span className="text-gray-400 text-xl font-semibold">|</span>
          <a href="#porque" className="hover:text-yellow-400 transition">
            ¿Por qué invertir?
          </a>
          <span className="text-gray-400 text-xl font-semibold">|</span>
          <a href="#contacto" className="hover:text-yellow-400 transition">
            Contacto
          </a>
        </nav>

        {/* Botón Hamburguesa Mobile */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1.5"
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-0.5 bg-white transition-transform duration-300 ${
              isMenuOpen ? "rotate-45 translate-y-2" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-white transition-opacity duration-300 ${
              isMenuOpen ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-white transition-transform duration-300 ${
              isMenuOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          ></span>
        </button>
      </div>

      {/* Menú Mobile */}
      <nav
        className={`md:hidden bg-black border-t border-gray-800 transition-all duration-300 ${
          isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="px-6 py-4 space-y-4">
          <a
            href="#modelo"
            className="block py-2 hover:text-yellow-400 transition"
            onClick={() => setIsMenuOpen(false)}
          >
            Modelo
          </a>
          <a
            href="#porque"
            className="block py-2 hover:text-yellow-400 transition"
            onClick={() => setIsMenuOpen(false)}
          >
            ¿Por qué invertir?
          </a>
          <a
            href="#contacto"
            className="block py-2 hover:text-yellow-400 transition"
            onClick={() => setIsMenuOpen(false)}
          >
            Contacto
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;